module.exports = __webpack_public_path__ + "img/Emerald.a773627.png";